import { render, staticRenderFns } from "./AddRequests.vue?vue&type=template&id=1b41735a&"
import script from "./AddRequests.vue?vue&type=script&lang=js&"
export * from "./AddRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports